import coreLibrary from "../../../helpers/CoreLibrary";

export const TabMixin = {
    extends: coreLibrary,
    props: {
        tabs: {
            type: Array,
            require: true
        },
        tabdate: {
            type: Object,
            require: true
        }
    },
    data() {
        return {
            preLoader: true,
            queryStringKey: 'tab',
            queryStringValue: '',
            currentIndex: 0,
            componentName: '',
            componentId: '',
            componentProps: '',
            componentTitle: '',
            componentButton: {},
            chart:[],
        }
    },
    computed: {
        filteredTab() {
            return this.tabs.filter((tab) => {
                if (!this.isUndefined(tab.permission)) {
                    if (tab.permission === false) {
                        return false
                    } else return true;
                }
                return true;
            });
        }
    },
    mounted() {
        this.queryStringValue = this.getQueryStringValue(this.queryStringKey);
        this.setTabByName();
    },
    methods: {
        setQueryString(name) {
            const pageTitle = window.document.title;
            window.history.pushState("", pageTitle, `?${this.queryStringKey}=${name}`);
        },

        getChart(set) {
            this.preLoader = true;
            this.axiosGet('/crm/warehouse-reports?type='+set.type+'&qty='+this.tabdate.qty+'&date_start='+this.tabdate.date_start+'&date_end='+this.tabdate.date_end+'&cat='+this.tabdate.cat)
                .then((res) => {
                    this.chart = res.data;
                })
                .finally(() => {
                    this.preLoader = false;
                });
        },

        setTabByName() {
            let currentTab = {},
                result = {};
            result = this.filteredTab.find((item, index) => {
                if (item.name == this.queryStringValue) {
                    this.currentIndex = index;
                    return item;
                }
            });

            currentTab = result ? result : this.filteredTab[this.currentIndex];

            this.loadComponent(currentTab, this.currentIndex);
        },

        loadComponent(tab, index) {
            this.currentIndex = index;
            this.componentTitle = tab.title;
            this.componentId = tab.name + '-' + index;
            this.componentName = tab.component;
            this.componentProps = tab.props;
            this.getChart(tab.props);
            if (!this.isUndefined(tab.headerButton)) {
                this.componentButton = tab.headerButton;
            } else this.componentButton = {};

            this.setQueryString(tab.name);
        }
    }
};
